import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider, Require } from "@/auth";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Demo from "@/pages/Demo";
import Buku from "@/pages/Buku";
import Perubahan from "@/pages/Perubahan";
import Minta from "@/pages/Minta";
import Verifikasi from "@/pages/Verifikasi";
import Daftar from "@/pages/Daftar";
import BuktiDampak from "@/pages/BuktiDampak";
import RuangKerja from "@/pages/RuangKerja";
import Undangan from "@/pages/Undangan";
import Dampak from "@/pages/Dampak";
import Sapuan from "@/pages/Sapuan";
import Sistem from "@/pages/Sistem";
import Pamit from "@/pages/Pamit";
import AngkaDasar from "@/pages/AngkaDasar";
import TidakDitemukan from "@/pages/TidakDitemukan";

const JUDUL = {
  "/": "PAM-IT — Pencatatan Akses Masuk-keluar IT",
  "/masuk": "Masuk — PAM-IT",
  "/demo": "Demo (data contoh) — PAM-IT",
  "/buku": "Buku — PAM-IT",
  "/permintaan": "Permintaan — PAM-IT",
  "/minta": "Minta perubahan akses — PAM-IT",
  "/daftar": "Daftar perusahaan — PAM-IT",
  "/bukti-dampak": "Bukti dampak — PAM-IT",
  "/dampak": "Dampak — PAM-IT",
  "/sapuan": "Sapuan — PAM-IT",
  "/akses": "Daftar Akses — PAM-IT",
  "/ruang-kerja": "Ruang Kerja — PAM-IT",
  "/pamit": "Pamit — PAM-IT",
  "/angka-dasar": "Angka Dasar — PAM-IT",
};

function Judul() {
  useEffect(() => {
    const j = JUDUL[window.location.pathname] ||
      (window.location.pathname.startsWith("/verifikasi") ? "Verifikasi Surat — PAM-IT" : "PAM-IT");
    document.title = j;
  });
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Judul />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/masuk" element={<Login />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/minta" element={<Minta />} />
            <Route path="/minta/:kode" element={<Minta />} />
            <Route path="/daftar" element={<Daftar />} />
            <Route path="/bukti-dampak" element={<BuktiDampak />} />
            <Route path="/undangan/:token" element={<Undangan />} />
            <Route path="/verifikasi/:nomor?" element={<Verifikasi />} />
            <Route path="/buku" element={<Require area="buku"><Buku /></Require>} />
            <Route path="/permintaan" element={<Require area="permintaan"><Perubahan /></Require>} />
            <Route path="/dampak" element={<Require area="dampak"><Dampak /></Require>} />
            <Route path="/sapuan" element={<Require area="sapuan"><Sapuan /></Require>} />
            <Route path="/akses" element={<Require area="sistem"><Sistem /></Require>} />
            <Route path="/sistem" element={<Require area="sistem"><Sistem /></Require>} />
            <Route path="/ruang-kerja" element={<Require area="ruang-kerja"><RuangKerja /></Require>} />
            <Route path="/pamit" element={<Require area="pamit"><Pamit /></Require>} />
            <Route path="/angka-dasar" element={<Require area="dasar"><AngkaDasar /></Require>} />
            <Route path="*" element={<TidakDitemukan />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
